import { getCurrency } from "helper/numberFormat";
import React from "react";

export const PriceType = ({
  value,
  handleClick,
  setFieldValue,
  index,
  type,
  discount,
  name,
  disabled
}) => {
  const currency = getCurrency();
  return (
    <div className="price-type-contant d-flex align-items-center">
      <span
        className={value === "%" ? "selected-price-type" : ""}
        onClick={() => {
          if(disabled) return;
          {
            setFieldValue(type, "%");
            setFieldValue(discount, "");
          }

          handleClick("%");
        }}
      >
        %
      </span>
      <span
        className={value === currency ? "selected-price-type" : ""}
        onClick={() => {
          if(disabled) return;
          {
            setFieldValue(type, currency);
            setFieldValue(discount, "");
          }
          handleClick(currency);
        }}
      >
      {currency}
      </span>
    </div>
  );
};
